// @todo This is currently named IWorkletOptions and not IAudioWorkletOptions because it defines the options of a generic Worklet.

export interface IWorkletOptions {
    credentials: 'include' | 'omit' | 'same-origin';
}
